<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="this.option"
      @vdropzone-error="handleError"
      @vdropzone-success="handleSuccess"
      @vdropzone-file-added="handleFileAdded"
      @vdropzone-removed-file="handleRemovedFile"
    >
    </vue-dropzone>
    <div class="info m-t-sm">
      <b class="text-red">※ファイルのアップロードは「アップロード」ボタンを押すことで完了となります。</b>
      <br>
      <span>※アップロードボタンを押した後、アップロード完了するまでしばらくお待ちください</span>
    </div>
    <div class="text-right m-t">
      <button :disabled="disableUpdloadFile" type="button" class="btn btn-warning m-w-120" @click="updateFiles">アップロード</button>
      <button type="button" class="btn m-w-120" data-dismiss="modal" @click="closeModal()">閉じる</button>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import store from '@/store'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import * as code from '@/common/code'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      loader: null,
      disableUpdloadFile: true
    }
  },
  computed: {
    option () {
      return {
        url: `${process.env.NODE_SERVER_API}EvidenceImage/upload`,
        headers: { 'Authorization': `Bearer ${localStorage.getItem('tokenSalmon')}` },
        thumbnailWidth: 300,
        maxFilesize: 1024,
        maxFiles: 1,
        acceptedFiles: 'image/jpg, image/jpeg, image/gif, image/png, image/bmp',
        addRemoveLinks: false,
        autoProcessQueue: false,
        dictDefaultMessage: '審査に必要なファイルを、ここにドラッグ＆ドロップ<br><br><button class="btn btn-info w-200">またはファイルを選択</button>',
        dictInvalidFileType: 'この形式のファイルはアップロードできません。',
        dictMaxFilesExceeded: '複数のファイルをアップロードすることはできません。',
        previewTemplate: `
          <div class="dz-preview custom-dz">
            <div class="file-icon">
              <i class="fa fa-file-text-o text-size-35" aria-hidden="true"></i>
            </div>
            <div class="file-info">
              <div class="file-name" data-dz-name></div>
              <div class="file-size" data-dz-size></div>
              <div class="file-error" data-dz-errormessage></div>
            </div>
            <div class="file-status">
              <i class="fa fa-check-circle text-success text-size-20" aria-hidden="true"></i>
              <button class="btn" data-dz-remove>
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        `
      }
    }
  },
  beforeDestroy () {
    this.$emit('close')
    this.$refs.myVueDropzone.removeAllFiles()
    $('.modal-backdrop').remove()
  },
  methods: {
    handleError (file, response, xhr) {
      if (xhr) {
        store.commit('toggleModal', {
          show: true,
          message: '審査用画像のアップロードに失敗しました。'
        })
        self.loader && self.loader.hide()
      }

      const icon = file.previewElement.querySelector('.file-icon i')
      if (icon) {
        icon.classList.remove('fa-file-text-o')
        icon.classList.add('fa-exclamation-triangle')
        icon.classList.add('text-danger')
      }

      const statusIcon = file.previewElement.querySelector('.file-status i')
      if (statusIcon) {
        statusIcon.classList.remove('fa-check-circle')
        statusIcon.classList.remove('text-success')
        statusIcon.classList.add('fa-exclamation-triangle')
        statusIcon.classList.add('text-danger')
      }
      this.disableUpdloadFile = true
    },
    handleSuccess (file, response) {
      self.loader && self.loader.hide()
      if (response.header.resultCode !== code.success) {
        this.$refs.myVueDropzone.removeAllFiles()
        store.commit('toggleModal', {
          show: true,
          message: response.header.message
        })
        return
      }

      store.commit('toggleModal', {
        show: true,
        message: '審査用画像のアップロードに成功しました。'
      })
      this.$emit('handleSuccess')
      this.closeModal()
    },
    handleFileAdded (file) {
      const dz = this.$refs.myVueDropzone.dropzone
      if (dz.files.length > 1) {
        dz.removeFile(dz.files[0])
      }
      this.disableUpdloadFile = false
    },
    handleRemovedFile (file, error, xhr) {
      this.disableUpdloadFile = true
    },
    updateFiles () {
      if (this.$refs.myVueDropzone.getQueuedFiles().length) {
        self.loader = this.$loading.show()
        this.$refs.myVueDropzone.processQueue()

        let logParams = {
          name: eventCode.warehouse_amazon.multi_channel_service_tab.click_upload_button,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      } else {
        this.closeModal()
      }
    },
    closeModal () {
      this.disableUpdloadFile = true
      this.$refs.myVueDropzone.removeAllFiles()
      this.$emit('close')
    }
  },
  mounted () {
    this.$refs.myVueDropzone.removeAllFiles()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EvidenceImageInput.vue